export default __webpack_public_path__ + "static/media/bd-ilustracion-nube.15c0484a.svg";